var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackGroundSectionOneLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 821,
    viewBox: "0 0 656 821",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.537 256.453C393.032 178.227 499.825 116.307 504.948 218.581C511.426 347.922 377.423 532.803 304.929 611.029C232.434 689.255 299.586 514.675 301.956 445.466C304.325 376.256 248.042 334.679 320.537 256.453Z",
    fill: "#4D20FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2_536)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.401,
    cy: 191.432,
    rx: 135.401,
    ry: 191.432,
    transform: "matrix(-0.0388745 -0.999244 0.654532 -0.756034 156.067 752.571)",
    fill: "#FFD90F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2_536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.477 305.027C346.848 253.911 416.362 221.3 419.166 303.998C422.712 408.584 334.946 535.322 287.576 586.438C240.205 637.554 284.599 508.444 286.484 453.408C288.368 398.372 252.106 356.143 299.477 305.027Z",
    fill: "#20E4FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_536",
    x: 121.364,
    y: 14.9933,
    width: 533.811,
    height: 765.799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2_536"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2_536",
    x: 0.691162,
    y: 124.421,
    width: 550.822,
    height: 696.245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2_536"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2_536",
    x: 115.8,
    y: 103.562,
    width: 453.47,
    height: 644.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2_536"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackGroundSectionOneLeft);
export default __webpack_public_path__ + "static/media/backGroundSectionOneLeft.eba5accfb728fa1a2c80ad76a6c6f9a6.svg";
export { ForwardRef as ReactComponent };